module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/bullet-6114b28a7f794558b46c15660585f229.svg";